import React from 'react';
import { shouldUpdate } from 'recompose';
import { equals } from 'ramda';

export default shouldUpdate(
    (props, nextProps) => props.className !== nextProps.className
        || props.label !== nextProps.label
        || props.value !== nextProps.value
        || props.children !== nextProps.children
        || !equals(props.classNames, nextProps.classNames)
)((props) => {
    const { className = '', classNames = {}, label, value, children } = props;

    return (
        <div className={className}>
            {label && <div className={classNames.label || ''}>{label}</div>}
            {value && <div className={classNames.value || ''}>{value}</div>}
            {children}
        </div>
    );
});
